module.exports = __webpack_public_path__ + "static/media/mobile-balance.b59364c1.svg";